module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/comment-o-0a726036ae4ba88aa8fca34aba8cbd01.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/comment-o.svg
// module id = EdeQ
// module chunks = 24